<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <SoonModal :active="soonModal" @close="soonModal=false"/>
      <!-- Title -->
      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"></i>
          </div>
          <div>
            <h2 class="clean-section-title has-text-white has-text-weight-bold">
              الخدمات المالية
            </h2>
            <!-- <h3 class="subtitle is-5 pt-20 has-text-white has-text-weight-bold">
              تتعلق هذه الخدمات بتحويل الأموال من حسابك إلى حسابات أخرى بمصرف
              الصحارى ، إمكانية طلب شراء جزء أو كل مخصصات أسرتك من النقد الأجنبي،
              بالإضافة إلى إمكانية طلب شراء النقد الأجنبي للأغراض الشخصية.
            </h3> -->
          </div>
        </div>

        <div class="columns is-vcentered">
          <div class="column is-4">
            <!-- <div
              class="flex-card icon-card-hover cash-card light-bordered padding-20"
              @click="makeRequestMoney('طلب حوالة سريعة مني جرام', 1)"
            > -->
            <div
              class="flex-card icon-card-hover cash-card light-bordered padding-20"
              @click="soonModal=true"
            >
              <h3 class="card-title has-text-link"> حوالة داخلية </h3>
              <p class="card-description">
                تحويل قيمة مالية من حسابك إلى حساب زبون
آخر في مصرف الصحارى"
عند النقر عليها تظهر رسالة
"هذه الخدمة تحت اإلنجاز وستكون متاحة قريباً
              </p>
            </div>
          </div>

          <div class="column is-4">
              <!-- <div
                class="flex-card icon-card-hover cash-card light-bordered padding-20"
                @click="makeRequest('شراء مخصصات أسرتك من النقد الأجنبي', 1)"
              > -->
              <div
                class="flex-card icon-card-hover cash-card light-bordered padding-20"
                @click="soonModal=true"
              >
                <h3 class="card-title has-text-link">
                  حوالة خارجية
                </h3>
                <p class="card-description">
                  "تحويل قيمة مالية من حسابك إلى حساب زبون
آخر في مصرف صديق"
عند النقر عليها تظهر رسالة
"هذه الخدمة تحت اإلنجاز وستكون متاحة قريباً"
                </p>
              </div>
            </div>
          
          <!-- <div class="column is-4">
            <div
              class="flex-card icon-card-hover cash-card light-bordered padding-20"
              @click="
                makePersonalRequest('شراء النقد الأجنبي للأغراض الشخصية', 1)
              "
            >
              <h3 class="card-title has-text-link is-clean">
                شراء النقد الأجنبي للأغراض الشخصية
              </h3>
              <p class="card-description">
                شراء مبلغ (المسموح به) من النقد الأجنبي على أن يتم خصم المقابل
                بالدينار الليبي من حسابكم الجاري بما في ذلك العمولات المقررة
                لذلك
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div
      class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
    >
      <router-link to="/portal">
        <a class="button is-dark btn-align modal-dismiss is-bold is-medium">
          <b>عودة للرئيسية</b>
        </a>
      </router-link>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";
import SoonModal from '../../components/SoonModal.vue';

export default {
  name: "visa",
  components:{SoonModal},
  data() {
    return {
      soonModal: false,
      customerdate: null,
      customertime: null,
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: 1,
      },
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.logItIn();
          return;
        }
      });
    },
    makeRequest(actionstring, action) {
      this.$router.push({
        name: "chargerequest",
        params: {
          requeststring: actionstring,
          requestid: action,
        },
      })
      // this.$dialog.confirm({
      //   message: "هل انت متأكد من طلب " + actionstring,
      //   cancelText: "لا",
      //   confirmText: "نعم",
      //   type: "is-success",
      //   onConfirm: () =>
      //     this.$router.push({
      //       name: "chargerequest",
      //       params: {
      //         requeststring: actionstring,
      //         requestid: action,
      //       },
      //     }),
      // });
    },
    makePersonalRequest(actionstring, action) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "chargerequestpersonal",
            params: {
              requeststring: actionstring,
              requestid: action,
            },
          }),
      });
    },
    makeRequestMoney(actionstring, action) {
      this.$router.push({
        name: "MoneyGram",
        params: {
          requeststring: actionstring,
          requestid: action,
        },
      });
      // this.$dialog.confirm({
      //   message: "هل انت متأكد من طلب " + actionstring,
      //   cancelText: "لا",
      //   confirmText: "نعم",
      //   type: "is-success",
      //   onConfirm: () =>
      //     this.$router.push({
      //       name: "MoneyGram",
      //       params: {
      //         requeststring: actionstring,
      //         requestid: action,
      //       },
      //     }),
      // });
    },
    // makeRequest(actionstring, action) {
    //   this.$router.push({
    //     name: "chargerequest",
    //     params: { requeststring: actionstring, requestid: action }
    //   });
    //   // this.isLoading = !this.isLoading;
    //   //   this.requestInfo.ServicAction_Id = action;
    //   //   axios.post('vs/newRequest',this.requestInfo)
    //   //  .then(response => {

    //   //        if (response.data.status === "success") {
    //   //          alert('request sent successfully');
    //   //     } else if (response.data.status === "fail") {
    //   //        console.log(this.response);
    //   //         alert('request fail');
    //   //     }
    //   //   })
    //   //   .catch(error => {
    //   //    this.isLoading = !this.isLoading;
    //   //     this.message = true;
    //   //   });
    // }
  },
};
</script>
